import {Component, OnInit} from '@angular/core';
import {UsuarioBc} from '../../model/usuario-bc';
import {AuthService} from '../../services/auth.service';
import {ToastrService} from 'ngx-toastr';
import {StorageService} from '../../services/storage.service';
import {Router} from '@angular/router';
import {Estabelecimento} from '../../model/estabelecimento';
import {Solicitacao} from '../../model/solicitacao';
import {RespostaUsuarioCns} from '../../model/usuario-cns';
import {cnpj, cns, cpf} from '../../util/format';

@Component({
  selector: 'app-resumo-solicitacao',
  templateUrl: './resumo-solicitacao.component.html',
  styleUrls: [ './resumo-solicitacao.component.scss' ],
})
export class ResumoSolicitacaoComponent implements OnInit {
  usuarioLogado: UsuarioBc;
  config: any;
  carregando = true;
  currentApp: any;
  estabelecimento: Estabelecimento = new Estabelecimento();
  solicitacao: Solicitacao = new Solicitacao();
  responsavel: RespostaUsuarioCns = new RespostaUsuarioCns();
  filhos = false;
  esus = false;
  sistemas = false;
  cnpj = cnpj;
  cns = cns;
  cpf = cpf;
  form: any;
  subform: any;

  constructor(
    private authService: AuthService,
    private toast: ToastrService,
    private storage: StorageService,
    private router: Router
  ) {
    this.currentApp = JSON.parse(this.storage.getCurrentApp());
    this.loadCurrent();
  }



  loadCurrent() {
    const solicitacao = localStorage.getItem('current-solicitacao');
    const estabelecimento = localStorage.getItem('current-estabelecimento');
    const responsavel = localStorage.getItem('current-responsavel');
    const filhos = localStorage.getItem('filhos');
    const esus = localStorage.getItem('esus');
    const sistemas = localStorage.getItem('sistemas');
    const form = localStorage.getItem('form');
    const subform = localStorage.getItem('subform');
    if (solicitacao) {
      this.solicitacao = JSON.parse(solicitacao);
      this.estabelecimento = JSON.parse(estabelecimento);
      this.responsavel = JSON.parse(responsavel);
      this.filhos = JSON.parse(filhos);
      this.esus = JSON.parse(esus);
      this.sistemas = JSON.parse(sistemas);
      this.form = JSON.parse(form);
      this.subform = JSON.parse(subform);
    }
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  async ngOnInit() {
    this.toast.toastrConfig.enableHtml = true;

    try {
      this.config = this.currentApp;
      this.usuarioLogado = this.authService.getUsuarioLogado();
      this.carregando = false;
    } catch (e) {
      this.toast.error('Ocorreu um erro.');
      this.carregando = false;
    }
  }

  goBack() {
    this.router.navigateByUrl('/solicitacao-de-acesso');
  }

  mapItem(arr) {
    return arr.map(function (elem) { return elem.name; }).join(',');
  }

  next() {
    console.log(this.solicitacao);
    this.router.navigateByUrl('/termos-de-uso');
  }


}



// WEBPACK FOOTER //
// ./src/app/components/resumo-solicitacao/resumo-solicitacao.component.ts